import { useLogin } from '@refinedev/core';
import { Alert, Button, Card, Typography, Space } from 'antd';
import { GoogleOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import { signInErrorMessage } from './signInErrors';

export const LoginPage: React.FC = () => {
  const { mutate: login, isLoading } = useLogin();
  const [searchParams] = useSearchParams();
  const errorMessage = signInErrorMessage(searchParams.get('error'));

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #6E247F 0%, #6470FF 100%)',
      }}
    >
      <Card style={{ width: 400, textAlign: 'center' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Typography.Title level={2} style={{ color: '#6E247F', margin: 0 }}>
            BackOffice
          </Typography.Title>
          <Typography.Text type="secondary">
            Sign in with your ServeFirst Google account
          </Typography.Text>
          {errorMessage && <Alert type="error" showIcon message={errorMessage} />}
          <Button
            type="primary"
            size="large"
            icon={<GoogleOutlined />}
            loading={isLoading}
            onClick={() => login({})}
            block
          >
            Sign in with Google
          </Button>
        </Space>
      </Card>
    </div>
  );
};
